import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generarObjetoServiciosCotizacion'
})
export class GenerarObjetoServiciosCotizacionPipe implements PipeTransform {

  transform(servicios: any):Array<any>{
    
    let arregloServicios:Array<any> = [];

    // Hace un loop por todos los servicios de la cotización
    for (let servicioID in servicios){
      let objServicio = { 
        idServicio : servicioID,
        conceptosAdicionales : 0,
        combinaciones : []
      };

      // Hace un loop por los conceptos adicionales
      if(servicios[servicioID].conceptosAdicionales != undefined)
        for (let conceptoAdicionalID in servicios[servicioID].conceptosAdicionales){
          objServicio.conceptosAdicionales += servicios[servicioID].conceptosAdicionales[conceptoAdicionalID].precio;
        }

      // Hace un loop por las combinaciones
      for (let combinacionID in servicios[servicioID].costoCombinaciones){
        let objCombinacion = {
          idCombinacion : combinacionID,
          precio : servicios[servicioID].precioCombinaciones[combinacionID],
          unidades : []
        };
        // Hace un barrido por las unidades de la combinación
        for(let unidad in servicios[servicioID].costoCombinaciones[combinacionID]){
          // Crea un objeto por tipo de unidad con la cantidad de unidades que seleccionó el usuario
          let objUnidad = {
            tipoDeUnidad : unidad,
            numeroDeUnidades : servicios[servicioID].costoCombinaciones[combinacionID][unidad].numeroDeUnidades
          };
          // Añade el objeto de unidades a la combinación
          objCombinacion.unidades.push(objUnidad);
        }
        objServicio.combinaciones.push(objCombinacion);
      }
      arregloServicios.push(objServicio);
    }

    return arregloServicios;
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/generar-objeto-servicios-cotizacion.pipe.ts